import { Box, Skeleton } from '@mui/material';

type Variant = 'dark' | 'light';

const skeletonSx = (variant: Variant) => ({
    borderRadius: '8px',
    bgcolor: variant === 'dark' ? 'rgba(26, 26, 26, 0.1)' : 'rgba(255, 255, 255, 0.3)',
});

interface AuthButtonsSkeletonProps {
    variant?: Variant;
}

/**
 * Skeleton placeholders that match the logged-in auth button group (Family Profile + Cart + Logout).
 * Prevents layout shift and signals that auth state is loading.
 */
const AuthButtonsSkeleton = ({ variant = 'dark' }: AuthButtonsSkeletonProps) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Skeleton
            variant="rounded"
            width={128}
            height={40}
            animation="pulse"
            sx={skeletonSx(variant)}
        />
        <Skeleton
            variant="rounded"
            width={40}
            height={40}
            animation="pulse"
            sx={skeletonSx(variant)}
        />
        <Skeleton
            variant="rounded"
            width={40}
            height={40}
            animation="pulse"
            sx={skeletonSx(variant)}
        />
    </Box>
);

export default AuthButtonsSkeleton;
